// extracted by mini-css-extract-plugin
export default {"list":"ProductivityWorkerGraph_list__QpAEr"};